import React from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";
import { ObservingCompareItems } from "./components/CompareCount";
import { ObservingCompareToggleItems } from "./components/CompareToggle";
import { ObservingCompareNotificationItems } from "./components/CompareNotification";

const compareCountNodes = document.querySelectorAll('.compare-count');

if (compareCountNodes.length > 0) {
    import(/* webpackChunkName: "CompareCount" */ './components/CompareCount').then(({ ObservingCompare: ObservingCompare }) => {
        [...compareCountNodes].forEach((node) => render(
            <ObservingCompareItems {...parseDatasetToProps(node.dataset)} />, node));
    });
}

const compareToggleNodes = document.querySelectorAll('.compare-toggle');

if (compareToggleNodes.length > 0) {
    import(/* webpackChunkName: "CompareToggle" */ './components/CompareToggle').then(({ ObservingCompare: ObservingCompare }) => {
        [...compareToggleNodes].forEach((node) => render(
            <ObservingCompareToggleItems {...parseDatasetToProps(node.dataset)} />, node));
    });
}

const compareNotificationNode = document.getElementById('compare-notification');

if (compareNotificationNode) {
    import(/* webpackChunkName: "CompareNotification" */ './components/CompareNotification').then(({ ObservingCompare: ObservingCompare }) => {
        render(<ObservingCompareNotificationItems node={compareNotificationNode} {...parseDatasetToProps(compareNotificationNode.dataset)} />, compareNotificationNode)
    });
}
